<template>
  <base-modal
    :modal-title="$t('addConfiguration')"
    :dialog-visible="modelValue"
    :confirm-text="$t('save')"
    width="400px"
    @close="close"
    @confirm="confirm"
  >
    <template #content>
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-position="top"
        @submit.prevent="confirm"
      >
        <el-form-item prop="apiName">
          <el-select v-model="form.apiName" size="small">
            <el-option
              v-for="item in localRemainingApiNames"
              :key="item ?? ''"
              :label="item ?? ''"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>
  </base-modal>
</template>
<script lang="ts">
import BaseModal from '@/components/modals/BaseModal.vue';
import { ElForm, ElFormItem, ElOption, ElSelect } from 'element-plus';
import { computed, reactive, ref } from 'vue';
import i18n from '@/i18n';
import { ApiName } from '@etp/etp-gain-bff-client/axios';

export default {
  name: 'NewApiConnectionsConfigurationModal',
  components: {
    BaseModal,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption
  },
  props: {
    modelValue: { type: Boolean, default: false },
    existingApiNamesValues: {
      type: Array as () => Array<number>,
      default: () => new Array<number>()
    }
  },
  emits: ['close', 'confirm'],
  setup(props, { emit }) {
    const form = reactive({
      apiName: ''
    });
    const formRef = ref<HTMLFormElement>();
    const formRules = reactive({
      apiName: [
        {
          required: true,
          message: i18n.global.t('thisFieldIsRequired'),
          trigger: 'blur'
        }
      ]
    });

    const localRemainingApiNames = computed((): Array<string> => {
      const remainingApiNamesValues = Object.values(ApiName).filter(apiName =>
        props.existingApiNamesValues.includes(apiName)
      );
      const remainingApiNames = remainingApiNamesValues.map(
        apiName =>
          Object.keys(ApiName).find(key => ApiName[key] === apiName) ?? ''
      );
      return remainingApiNames;
    });

    const confirm = () => {
      formRef.value?.validate((valid: boolean) => {
        if (valid) {
          emit('confirm', ApiName[form.apiName]);
        }
      });
    };
    const close = () => {
      emit('close');
    };

    return {
      form,
      formRules,
      formRef,
      confirm,
      close,
      localRemainingApiNames
    };
  }
};
</script>
